import React, { Component } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useRouteMatch } from "react-router-dom";
import QbankQ  from './qbankQ.svg';
import qBankApi from '../services/qbankApi';
import './HeadBar.css';

class SubscriptionMenuItem extends Component {
    render() {
        let displayStringClass = `product-name ${this.props.isActiveSubscription ? 'active-product': 'inactive-product'}`

        return (
            <MenuItem header={this.props.header} eventKey={this.props.eventKey} onSelect={this.props.onSelect}>
                <div className={displayStringClass}>{this.props.subscription.product.name}</div>
            </MenuItem>
        );
    }
}

class ProfileDropdown extends Component {
    constructor(props){
        super(props);
        this.state = {
            showSubscriptionMenu: false,
            menuOpen: false
        };
        this.dropdownToggle = this.dropdownToggle.bind(this);
        this.handleSelectAccountSettings = this.handleSelectAccountSettings.bind(this);
        this.handleSelectSubscription = this.handleSelectSubscription.bind(this);
        this.handleToggleSubscriptionMenu = this.handleToggleSubscriptionMenu.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleVisitStore = this.handleVisitStore.bind(this);
    }

    // Hack to keep dropdown open when the toggle subscription menu item is selected
    dropdownToggle(newValue){
        if (this._forceOpen){
            this.setState({ menuOpen: true });
            this._forceOpen = false;
        } else {
            this.setState({
                menuOpen: newValue,
                showSubscriptionMenu: false
            });

        }
    }

    handleSelectAccountSettings(eventKey, event) {
        window.location.href = "/resetpassword"
    }

    handleToggleSubscriptionMenu(eventKey, event) {
        this._forceOpen = true;
        this.setState({showSubscriptionMenu: !this.state.showSubscriptionMenu});
    }

    handleSelectSubscription(eventKey, event) {
        let newActiveSubscription = this.props.me.subscriptions.find((subscription) => {
            return subscription.product.uuid === eventKey;
        });
        this.props.setActiveSubscription(this.props.me, newActiveSubscription);
    }

    handleLogout() {
        qBankApi.doLogout().then(() => window.location.reload());
    }

    handleVisitStore() {
        window.location.href = "/store";
    }

    render() {
        const caretName = this.state.showSubscriptionMenu ? "caret-down" : "caret-right";

        return (
            <div>
                <Dropdown open={this.state.menuOpen} onToggle={this.dropdownToggle} id="user-header-dropdown" pullRight>
                    <Dropdown.Toggle>
                        <span className="username">
                            {this.state.username}
                        </span>
                        <FontAwesomeIcon icon="user-circle" size="2x"/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <MenuItem header>{this.props.me.username}</MenuItem>
                        {this.props.activeSubscription &&
                            <SubscriptionMenuItem isActiveSubscription={true} header={true} eventKey="2" subscription={this.props.activeSubscription}></SubscriptionMenuItem>
                        }
                        {
                            this.props.me.subscriptions &&
                            this.props.me.subscriptions.length > 1 &&
                            <MenuItem onSelect={this.handleToggleSubscriptionMenu}>
                                <span>Change active product</span>
                                <FontAwesomeIcon className="subscription-menu-caret" icon={caretName}></FontAwesomeIcon>
                            </MenuItem>
                        }
                        <MenuItem onSelect={this.handleVisitStore}>
                            Visit QBank Store
                        </MenuItem>
                        {
                            this.props.me.subscriptions && this.state.showSubscriptionMenu &&
                            this.props.me.subscriptions.filter((subscription) => {
                                return subscription.product.uuid !== this.props.activeSubscription.product.uuid;
                            }).map((inactiveSubscription) => {
                                return (
                                    <SubscriptionMenuItem className="inactive-subscription" eventKey={inactiveSubscription.product.uuid} key={inactiveSubscription.product.uuid} subscription={inactiveSubscription} onSelect={this.handleSelectSubscription}>
                                    </SubscriptionMenuItem>
                                )
                            })
                        }
                        <MenuItem divider />
                        <MenuItem eventKey="1" onSelect={this.handleLogout}>Logout</MenuItem>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
}

const HeadBar = ({ me, activeSubscription, setActiveSubscription }) => {
    const isTakingTest = !!useRouteMatch("/tests/:testId/run");

    const logo = <img src={QbankQ} className="qbank-q-logo" alt="home" />;
    return (
        <div className="headbar">
            <div className="home">
                {/* Logo isn't a link while taking a test */}
                {!isTakingTest ? (
                    <Link disabled to="/" className="btn-link">
                        {logo}
                    </Link>
                ) : (
                    logo
                )}
            </div>
            <ProfileDropdown
                me={me}
                activeSubscription={activeSubscription}
                setActiveSubscription={setActiveSubscription}
            />
        </div>
    );
};


export default HeadBar;
